
export default {
  props: {
    options: Object,
  },

  data(){
    return{
      circle: null,
      circleLoaded: false
    }
  },

  methods: {
    init(){
      this.circle = new this.$parent.google.maps.Circle({
        map: this.$parent.map,
        ...this.options
      });

      this.circleLoaded = true;
    }
  },
}
